(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    event.preventDefault();
    try {
      const formData = event.detail.form;
      const response = await fetch('/cart/add.js', {
        method: 'POST', body: formData, headers: { 'Accept': 'application/javascript' }
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        event.detail.reject(err);
        return;
      }
      const data = await response.json();
      try {
        const cartResp = await fetch('/cart.js');
        const cartData = await cartResp.json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
        document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cartData.item_count; });
      } catch (e) {}
      event.detail.resolve(data);
      const drawer = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else if (drawer) {
        drawer.classList.add('is-open','active','open');
        document.body.classList.add('cart-drawer-open');
        document.dispatchEvent(new CustomEvent('cart:open'));
      } else {
        document.dispatchEvent(new CustomEvent('cart:open'));
      }
    } catch (error) {
      console.error('ATC error:', error);
      event.detail.reject(error);
    }
  });
  document.addEventListener('product-form:cart:navigate', (event) => { event.preventDefault(); });

  } catch(e) { console.error(e); }
})();
})();
